<div class="btn-group btn-digest-group">

  <label *ngFor="let option of options" class="btn btn-sm btn-digest"
         [class.active]="isOptionActive(selectedOption, option.value)"
         (click)="selectOption(option)">{{ option.label | translate }}</label>

</div>

